import { jsx as o } from "react/jsx-runtime";

import e from "@ui-components-3/ui/lib/components/Checkbox";

import r from "@ui-components-3/ui/lib/components/FormControl";

import { forwardRef as a, useCallback as m } from "react";

import { useController as l, useFormContext as t } from "react-hook-form";

const n = a((({formControlProps: a, label: n, className: s, checkboxClassName: c, name: i, ...u}, h) => {
    const {field: p} = l({
        name: i
    }), {setValue: f} = t(), d = m((() => {
        f(i, !p?.value, {
            shouldValidate: !0,
            shouldDirty: !0,
            shouldTouch: !0
        }), p?.onBlur();
    }), [ p, i, f ]);
    return o(r, {
        labelPlacement: "right",
        ...a,
        label: n,
        className: s,
        children: o(e, {
            ...u,
            ...p,
            checked: !!p?.value,
            onChange: d,
            ref: h,
            className: c,
            name: i
        })
    });
}));

n.displayName = "FormCheckbox";

export { n as default };
//# sourceMappingURL=FormCheckbox.js.map
